import axios from 'axios';
import ENV from '../constants/Environment.js';

export default new class ReservationsService {

	async get(pDate) {
		const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/reserve/${pDate}`);
        return response.data.results;
	}
	
    async save(pRequest) {
        const options = {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			data: {
				"name": pRequest.Name,
				"phone": pRequest.Phone,
				"partySize": pRequest.PartySize,
				"serviceID": pRequest.ServiceID
			},
			url: `${ENV.HEROKU_API_ENDPOINT}/reserve/`,
		};

		try {
			const response = await axios(options);
			return {
				statusCode: response.status,
				results: response.data.results
			}
		} catch (error) {
			return {
				statusCode: error.response.status,
				results: error.response.data
			}
		}
    }

}
